import React, { useEffect, useState} from 'react';
import "./Clock.css"

const Clock = () => {
    const [day, setDay] = useState("");
    const [time, setTime] = useState({h:"", m:"", s:""});
    const [title, setTitle] = useState("");
    const [startDate, setStartDate] = useState(new Date().getTime());
    const [load, setLoad] = useState(false);


    useEffect(() => {
        const fetchStartTime = async () => {
          try {
            const response = await fetch("https://server.ben-bea.com/clock", {
                credentials: 'include'
            });
            const data = await response.json();
            
            setTitle(data.title);
            setStartDate(new Date(data.start).getTime());
            setLoad(true);
            
          } catch (error) {
            console.error("Failed to fetch start time:", error);
            setTitle("Error loading start time.");
          }
        };
    
        fetchStartTime();
      }, []);

    useEffect(() => {
        const update = () => {
            const now = new Date().getTime();
            const diff = now - startDate;

            const d = Math.floor(diff / (1000 * 60 * 60 * 24));
            const h = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const m = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
            const s = Math.floor((diff % (1000 * 60)) / 1000);    

            setDay(d);
            setTime({h, m, s});

        };

        update();
        const interval = setInterval(update, 1000);
        return () => clearInterval(interval);
    }, [startDate]);
    return(
      <>
        {
          load ? 
          (
            <div className='clock'>
              <p className='title'>{title}</p>
              <p className='day'>{day} days</p>
              <p className='time'>
                  {time.h}:{String(time.m).padStart(2, '0')}:{String(time.s).padStart(2, '0')}
              </p>
            </div>
          )
          :
          (
            <p></p>
          )
        }
      </>
    );
};

export default Clock;
